var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.gettingChatRooms,
          expression: "gettingChatRooms"
        }
      ],
      staticClass: "chatContainer",
      staticStyle: { height: "600px", border: "1px solid #eee" }
    },
    [
      _c(
        "el-aside",
        { attrs: { width: "300px" } },
        [
          _c("ChatRooms", {
            on: { manageRooms: _vm.manageTheRooms, viewRoom: _vm.viewRoom }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-main",
        [
          !_vm.manageRooms
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.gettingChatRoom || _vm.gettingChatRoomUsers,
                      expression: "gettingChatRoom || gettingChatRoomUsers"
                    }
                  ]
                },
                [
                  !_vm.activeChat.label
                    ? _c("div", { staticClass: "chatLabel" }, [
                        _vm._v(
                          "\n        Επιλέξτε συνομιλία από το μενού αριστερά\n      "
                        )
                      ])
                    : _vm.activeChat &&
                      _vm.activeChat.messages &&
                      _vm.activeChat.messages.length < 1
                      ? _c("div", { staticClass: "chatLabel" }, [
                          _vm._v(
                            "\n        Στείλτε το πρώτο μήνυμα στην συνομιλία " +
                              _vm._s(_vm.activeChat.label) +
                              " με τους " +
                              _vm._s(_vm.smallChatMembers) +
                              "\n      "
                          )
                        ])
                      : _c(
                          "div",
                          { staticClass: "chatLabel" },
                          [
                            _vm._v(
                              "Συνομιλία " +
                                _vm._s(_vm.activeChat.label) +
                                " με τους " +
                                _vm._s(_vm.smallChatMembers) +
                                "\n        "
                            ),
                            _vm.activeChat.messages.length <=
                            _vm.activeChat.total
                              ? _c("el-pagination", {
                                  attrs: {
                                    small: "",
                                    "hide-on-single-page": "true",
                                    total: _vm.activeChat.total,
                                    background: "",
                                    "current-page": _vm.currentPage,
                                    "page-sizes": [5, 10, 20, 50, 100],
                                    "page-size": 10,
                                    layout: "total, sizes, prev, pager, next",
                                    "page-count": 5
                                  },
                                  on: {
                                    "current-change": _vm.handleCurrentChange,
                                    "size-change": _vm.handleSizeChange,
                                    "update:currentPage": function($event) {
                                      _vm.currentPage = $event
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                  _vm._v(" "),
                  _vm.activeChat.label
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content: "Ανανέωση Συνομιλίας",
                                placement: "top-start"
                              }
                            },
                            [
                              _c("el-button", {
                                staticClass: "refreshButton",
                                attrs: {
                                  type: "danger",
                                  icon: "el-icon-refresh"
                                },
                                on: { click: _vm.refreshChat }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.activeChatMessages, function(message) {
                    return _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.manageRooms,
                            expression: "!manageRooms"
                          }
                        ],
                        key: message.time,
                        class: _vm.messageClass(message.username)
                      },
                      [
                        _c("img", {
                          class: _vm.avatarClass(message.username),
                          attrs: {
                            src: _vm.imageSrc(message.username),
                            alt: "Avatar"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "messageText" }, [
                          _vm._v(_vm._s(message.text))
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("span", { staticClass: "time-right" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(message.time) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "time-left" }, [
                            _vm._v(
                              "\n            Αίτηση: " +
                                _vm._s(message.app_id) +
                                "\n            Χρήστης: " +
                                _vm._s(message.username) +
                                "\n          "
                            )
                          ])
                        ])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.activeChat.id,
                          expression: "activeChat.id"
                        },
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.sendingMessage,
                          expression: "sendingMessage"
                        }
                      ]
                    },
                    [
                      _c("el-input", {
                        staticClass: "inputAppId",
                        attrs: { placeholder: "Αρ. Αίτησης" },
                        model: {
                          value: _vm.applicationId,
                          callback: function($$v) {
                            _vm.applicationId = $$v
                          },
                          expression: "applicationId"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content:
                              "Αναζήτηση μηνυμάτων σχετιζόμενα με συγκεκριμένη αίτηση",
                            placement: "top-start"
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.filterAppId }
                            },
                            [_vm._v("Αναζήτηση")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("el-input", {
                            staticClass: "inputMessage",
                            attrs: {
                              type: "textarea",
                              autosize: { minRows: 2, maxRows: 4 },
                              placeholder: "Please input"
                            },
                            model: {
                              value: _vm.message,
                              callback: function($$v) {
                                _vm.message = $$v
                              },
                              expression: "message"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.sendMessage }
                            },
                            [_vm._v("Αποστολή")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.manageRooms ? _c("manageChatRoom") : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a55bd3b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a55bd3b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/chat/Chat.vue
// module id = null
// module chunks = 